import * as d3 from 'd3';

import kernelDensityEstimator from './kernelDensityEstimator';
import kernelEpanechnikov from './kernelEpanechnikov';


const CalculatePreviewDensity = (val) => {
	// let newScaledData = [];
	let minDataPoint = d3.min(val);
	let maxDataPoint = d3.max(val);

	let x = d3.scaleLinear().domain([minDataPoint,maxDataPoint]).range([0, 140]);
	// console.log('KDE about to start')
	let kde = kernelDensityEstimator(kernelEpanechnikov((maxDataPoint-minDataPoint)/15), x.ticks(40));
	let density =  kde(val);

	let xDensity = density.map(function(elt) { return elt[0]; });
	let yDensity = density.map(function(elt) { return elt[1]; });

	let xDensityMax = d3.max(xDensity);
	let xDensityMin = d3.min(xDensity);

	density.unshift([xDensityMin-Math.abs(xDensityMax-xDensityMin)*0.01,0])
	density.unshift([xDensityMin-Math.abs(xDensityMax-xDensityMin)*0.2,0])
	density.push([xDensityMax+Math.abs(xDensityMax-xDensityMin)*0.01,0])
	density.push([xDensityMax+Math.abs(xDensityMax-xDensityMin)*0.2,0])

  let y = d3.scaleLinear()
    .range([100, 0])
    .domain([0, d3.max(yDensity)]);

  // Check: Because the variable was defined above it doesnt make sense to have it declared here again
  // So for this reason I am only changing its value
  // let x = d3.scaleLinear()
	x = d3.scaleLinear()
    .domain([xDensityMin-Math.abs(xDensityMax-xDensityMin)*0.2, xDensityMax+Math.abs(xDensityMax-xDensityMin)*0.2])
    .range([0, 140]);

	for (let i = 0; i < density.length; i++) {
		density[i] = [x(density[i][0]), y(density[i][1])];
  }

	// console.log('the non-highlight density has this many values', density.length)

	let result = {

		density: density,
		yDensity: yDensity

	}
	
	return result;
}

export default CalculatePreviewDensity;
